/**
 * Retailer has opted out of the POS marketing banners
 */ export var POS_MARKETING_BANNERS_DISMISSED = 'POS_MARKETING_BANNERS_DISMISSED';
